// Add your custom JS here.
(function($) {
   
    if( $('.hero-swiper').length ) {
        var swiper = new Swiper(".hero-swiper", {
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

})( jQuery );
